export enum RequestStatus {
    PendingApproval = 1,
    Approved = 2,
    Rejected = 3,
    Paid = 4,
    Expired = 5,
    Deleted = 6,
    PendingForReview = 10,
    Deactivated = 11,
}
